import { useState } from "react";

function Discount({ getPriceDiscount }) {
    const [discountprice, setDiscountPrice] = useState(0);
    const [status, setStatus] = useState(false);

    const handleApplyDiscount = () => {
        setDiscountPrice(-100000);
        getPriceDiscount(-100000);
        setStatus(true);
    };

    const handleCancelDiscount = () => {
        setDiscountPrice(0);
        getPriceDiscount(0);
        setStatus(false);
    };

    return (
        <div style={{ margin: 0, padding: 0 }} className="container">
            <div className="row g-3">
                <div className="col-12 col-lg-12 d-flex">
                    <div

                    >
                        <div className="card-body p-3">
                            <div className="mb-2">
                                <div className="d-flex align-items-center">

                                    <div className="input-group ">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="promoCodeInput"
                                            placeholder="Nhập mã của bạn"
                                            style={{ backgroundColor: "white" }}
                                            value="TIDADIGI"
                                            readOnly
                                        />
                                        <button
                                            className="btn"
                                            style={{
                                                backgroundColor: status ? "#BE2E30" : "#0069ff",
                                                color: "white",
                                            }}
                                            onClick={status ? handleCancelDiscount : handleApplyDiscount}
                                        >
                                            {status ? "Hủy" : "Áp Dụng"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default Discount;
